import { createApp } from 'vue';
import CategoryOverview from '../vue/CategoryOverview.js';

const PRODUCTS_API_URL = '/umbraco/api/products/getproducts';

function fetchProducts(body) {
    return fetch(PRODUCTS_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        body: JSON.stringify(body)
    }).then(r => r.json());
}

export function categoryOverview() {
    document.querySelectorAll('.category-overview__app').forEach(el => {
        let filterProperties = [];
        try {
            filterProperties = JSON.parse(el.dataset.filterProperties || '[]');
        } catch (e) {
            filterProperties = [];
        }

        const config = {
            categoryNodeId: parseInt(el.dataset.categoryNodeId) || 0,
            pageSize: parseInt(el.dataset.pageSize) || 8,
            culture: el.dataset.culture || 'da-DK',
            filterLabel: el.dataset.filterLabel || 'Filtrer produkter',
            filterProperties
        };
        if (!config.categoryNodeId) return;

        fetchProducts({ categoryNodeId: config.categoryNodeId, skip: 0, take: config.pageSize, cultureCode: config.culture, filterProperties: config.filterProperties, filters: [] })
            .then(data => {
                createApp(CategoryOverview, { config, initial: data, fetchProducts }).mount(el);
            })
            .catch(err => console.error('Failed to load products', err));
    });
}
